
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signup/[[...index]]",
      function () {
        return require("private-next-pages/auth/signup/[[...index]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/signup/[[...index]]"])
      });
    }
  